import React from "react";
import { useRef, useState } from "react";
import { validateFiles } from "../../helpers/validate-file";
import { DocumentNameDialog } from "../../dialogs/document-name/document-name-dialog";

interface Options {
  accept: string;
  multiple?: boolean;
  disabled?: boolean;
  onUpload: (file: any) => Promise<void>;
  path: string;
  segment?: string;
}

export const useDocumentUploader = ({
  accept,
  multiple = false,
  disabled = false,
  onUpload,
  path,
  segment,
}: Options) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const [selectedFile, setSelectedFile] = useState<any>([]);
  const [showNameModal, setShowNameModal] = useState(false);

  // open file dialog
  const openUploader = () => {
    if (!disabled) {
      const element: any = inputRef.current;
      element.click();
    }
  };

  // file selected
  const handleChange = async (e: any) => {
    const files = e.target.files;
    const validated = await validateFiles(files, accept);
    if (validated.length) {
      setSelectedFile(validated[0]);
      setShowNameModal(true);
    }
    const element: any = inputRef.current;
    element.value = "";
  };

  const handleModalClose = async (file?: string) => {
    setShowNameModal(false);
    if (file) {
      await onUpload(file);
      setSelectedFile(null);
    }
    if (!file || !selectedFile) return;
  };

  // hidden input + modal renderer
  const UploadUI = () => (
    <>
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        multiple={multiple}
        style={{ display: "none" }}
        onChange={handleChange}
        disabled={disabled}
      />

      {showNameModal && (
        <DocumentNameDialog
          file={selectedFile}
          path={path}
          segment={segment}
          show={showNameModal}
          onClose={handleModalClose}
        />
      )}
    </>
  );

  return {
    openUploader,
    UploadUI,
  };
};
